"use client";

import { useFlashDeals } from "@/hooks/useFlashDeals";

export function FlashDealsTimer({ endsAt }: { endsAt: string }) {
  const { minutes, seconds } = useFlashDeals(endsAt);
  const time = minutes === null ? "--:--" : `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return (
    <div className="flex items-center gap-2 text-sm text-foreground">
      <span>Termina em</span>
      <time
        dateTime={endsAt}
        className="min-w-16 rounded-lg bg-primary-hover px-2.5 py-1.5 text-center font-bold tabular-nums text-white"
        aria-label={minutes === null ? "Atualizando tempo da oferta" : `A oferta termina em ${minutes} minutos e ${seconds} segundos`}
      >
        {time}
      </time>
    </div>
  );
}
